import { useContext, useEffect,useState } from "react"
import { Flex, Flexed, Input, Label, MainWrap, NewSelectbox } from "../../utilities/Shared"
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid';
import Dropdown from "../../utilities/Dropdown";
import Select from 'react-select'
import { toast } from 'react-toastify'
import UserContext from "../../Context/UserContext";

const EstimateForm = () => {
    const param = useParams()
    const [papers, setPapers] = useState([])
    const [quote, setQuote] = useState({})
    const [estimator, setEstimator] = useState()
    const [customerOptions, setCustomerOptions] = useState([]);

    const { userInfo } = useContext(UserContext)

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const res = await axios.get('http://localhost:5001/customers/all');
                const opts = res.data.map(cust => ({
                    value: cust._id,
                    label: cust.name,
                    customer: cust
                }));
                console.log(opts)
                setCustomerOptions(opts);
               // setCustomers(res.data); // Keep full list for lookup
            } catch (err) {
                toast.error("Could not load customers");
            }
        };
        fetchCustomers();
    }, []);


    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        }
    }; 


    useEffect(() => {
        const getquote = () => {
            let r = {
                quote: param.quote
            }
            axios.post(`http://localhost:5001/rfq/getrfq`, r)
                .then(res => {
                    if (res.data.length === 0) {
                        console.log('no new quote')
                     getoldquote()
                    } else {
                        console.log('getting old quote')
                        setQuote(res.data[0])
                    }
                })
                .catch(err => { console.log(err); })
        }

        getPapers()
        getquote()
    }, [])

    console.log(userInfo.fullName)
    const getoldquote = async (quoteId, estimator = null) => {  // assuming you pass the quote ID
        try {
            let stuff = [];

            const payload = {
                quote:  param.quote  // or whatever param.quote was meant to be
            };

            // First request: get the RFQ quote
            const res = await axios.post(
                'https://highgroundsoftware.com/dash/dashboard/php/getrfqquote.php',
                payload,
                config
            );

            const data = res.data;

            if (!data) {
                throw new Error('No data returned from server');
            }

            const quan = data.quantity?.split(',') || [];
            const quantities = quan.map(q => q.trim()).filter(q => q).sort();

            // Refactored: handle up to 10 components dynamically
            for (let i = 1; i <= 10; i++) {
                const comp = data[`comp${i}`];
                if (comp) {
                    stuff.push(convertcomp(comp, quan));
                }
            }

            console.log('Processed components:', stuff);

            // Second request: send customer data (only if customer exists)
            if (data.customer) {
                try {
                    // FIX: Replace :supplyid with actual value if needed, or fix the endpoint
                    // Example: assuming you have a supplyid in dat
                    
                   // const customerEndpoint = `http://localhost:5001/customer/hg/name/:supplyid`;
                    await axios.get(`http://localhost:5001/customers/hg/name/${data.customer}`)
                    .then(res => console.log(res.data))
                    console.log('Customer data sent successfully');
                  
                } catch (customerErr) {
                    console.warn('Failed to send customer data:', customerErr);
                    // Decide: fail hard or continue?
                    // throw customerErr; // uncomment if this request is critical
                }
            }

            // Final state update
            setQuote({
                ...data,
                forms: stuff,
                quantities,
                estimator: estimator || userInfo?.fullName
            });

        } catch (err) {
            console.error('Error in getoldquote:', err);
            // Optionally show user feedback
            // e.g., toast.error('Failed to load quote');
        }
    };

    console.log(quote)
    const convertcomp = (info, quan) => {
        let arr = info.split(':');

        let y = {
            paper: convertpaper(arr[1]),
            componentName: arr[0],
            flatWidth: arr[4],
            flatLength: arr[5],
            pieceWidth: arr[6],
            pieceLength: arr[7],
            finks: arr[8],
            binks: arr[9],
            faq: arr[12],
            baq: arr[13],
            fbleed: arr[10],
            bbleed: arr[11],
            runon: arr[20],
            score: arr[21],
            perf: arr[22],
            diecut: arr[23],
            foldStyle: arr[24],
            pages: arr[25],
            addid: uuidv4(),
            quantity: quan
        }
        return y
    }

    const convertpaper = (item) => {
        let yy = { label: item, value: "" }
        let y = papers.filter(paper => paper.name === item)
        if (y[0]) { yy = { label: y[0].name, value: y[0]._id } }

        return yy
    }

    const getPapers = async () => {
        // await axios.get(`https://highgroundapi.herokuapp.com/paper/all`)
        await axios.get(`http://localhost:5001/paper/all`)

            .then(res => { setPapers(res.data) })
            .catch(err => console.log(err))
    }

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            position: 'relative',
            borderRadius: '5px',
            height:'30px',
            width: '100%', // or pass as prop
            border: state.isFocused
                ? '1px solid rgba(122, 187, 67, 1)'
                : '1px solid rgba(0, 0, 0, 0.3)',
            borderLeft: '10px solid rgba(122, 187, 67, 0.5)',
            outline: 'none',
            fontSize: 'calc(.9rem + .2vw)',
            color: 'black',
            backgroundColor: 'white',
            boxShadow: state.isFocused ? '0 0 0 2px rgba(122, 187, 67, 0.5)' : 'none',
            '&:hover': {
                borderColor: 'rgba(122, 187, 67, 0.7)'
            }
        }),
        singleValue: (provided) => ({
            ...provided,
            color: 'black'
        }),
        // Add other parts as needed (menu, option, etc.)
    };


    return (
        <MainWrap >
            <div style={{ paddingTop: "60px" }}>
            <Flexed>
                <Flex flex="1.5">
                    <Label>Customer</Label><br />
                        <Select
                           
                            styles={customStyles}
                        options={customerOptions}
                        placeholder="Search customer..."
                        isClearable
                    />
                </Flex>
                    <Flex flex="2">
                    <Label>Project</Label><br />
                        <Input  height="38px" type="text"/>
                </Flex>
                <Flex>
                    <Label>Project Style</Label><br />
                        <NewSelectbox
                        options={customerOptions}
                        placeholder="Search customer..."
                        isClearable
                    />
                </Flex>
                <Flex>
                    <Label>Estimator</Label><br />
                        <Input type="text" height="38px" defaultValue={quote?.estimator} disabled={true} />
                </Flex>
            </Flexed>

            </div>
        </MainWrap>
    )
}
export default EstimateForm